import { Button, Color, Divider, Icon, Space, Text } from '@billy/design-system'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import { useFetchVatDeclarationAuditTrail } from '../../../../../../hooks/useFetchVatDeclarationAuditTrail'
import { useTrackVatDeclarationEvent } from '../../../../../../hooks/useTrackVatDeclarationEvent'
import { VatDeclarationUrlParams } from '../../../../../../types/vatDeclarationUrlParams'
import { AuditTrailView } from './elements/AuditTrailView'
import * as Styled from './styles'

export const AuditTrail = () => {
  const { t } = useTranslation()
  const trackEvent = useTrackVatDeclarationEvent()
  const { vatDeclarationId } = useParams<VatDeclarationUrlParams>()

  const [isExpanded, setIsExpanded] = useState(false)
  const [showVoided, setShowVoided] = useState(true)

  const { data, isFetching, isLoading } = useFetchVatDeclarationAuditTrail({ showVoided, vatDeclarationId })

  const isAuditTrailLoading = isLoading || !data.length

  const handleAuditTrailToggle = useCallback(() => {
    trackEvent('xxx - Bookkeeping - VAT - Audit Trail', {
      buttonClick: !isExpanded ? 'Show audit trail' : 'Hide audit trail',
    })
    setIsExpanded(!isExpanded)
  }, [isExpanded, trackEvent])

  const handleShowVoidedToggle = useCallback(() => {
    trackEvent('xxx - Bookkeeping - VAT - Audit Trail', {
      buttonClick: !showVoided ? 'Show voided' : 'Hide voided',
    })
    setShowVoided(!showVoided)
  }, [showVoided, trackEvent])

  return (
    <Styled.AuditTrailWrapper>
      <Space size="s40" />
      <Button
        variant="text"
        fullWidth={false}
        disabled={isAuditTrailLoading}
        onClick={handleAuditTrailToggle}
        icon={<Icon icon={isExpanded ? 'eyeOff' : 'eye'} color={Color.Black} />}
      >
        <Text variant="bodyMD" weight="semiBold">
          {t(
            isExpanded
              ? 'vat_declaration.audit_trail.button.label_hide'
              : 'vat_declaration.audit_trail.button.label_show',
          )}
        </Text>
      </Button>
      {isExpanded && (
        <>
          <Space size="s40" />
          <Divider />
          <Space size="s24" />
          <AuditTrailView
            data={data}
            isRefetching={isFetching}
            showVoided={showVoided}
            setShowVoided={handleShowVoidedToggle}
          />
        </>
      )}
    </Styled.AuditTrailWrapper>
  )
}
